// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import AdditionalServicesSection from './components/AdditionalServicesSection';
import PricingSection from './components/PricingSection';
import Footer from './components/Footer';
import { motion } from 'framer-motion';

// Footer wave wrapper component
const FooterWithWave = ({ pricingActive }) => {
  return (
    <div className={pricingActive ? 'relative bg-black mt-0' : 'relative -mt-[250px] md:-mt-[400px]'}>
      {pricingActive && (
        <div className="w-full overflow-hidden">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
            <path 
              fill="#001233" 
              fillOpacity="1" 
              d="M0,96L48,117.3C96,139,192,181,288,186.7C384,192,480,160,576,144C672,128,768,128,864,144C960,160,1056,192,1152,202.7C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      )}
      <Footer />
    </div>
  );
};

function App() {
  const [activeSection, setActiveSection] = useState('home');

  // Function to be passed to Navbar for section changes
  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary overflow-hidden relative">
      <Navbar onSectionChange={handleSectionChange} />
      <main className="relative">
        {activeSection === 'pricing' ? (
          <PricingSection />
        ) : (
          <>
            <HeroSection />
            <AboutSection />
            <ServicesSection />
            <AdditionalServicesSection />
          </>
        )}
      </main>
      <FooterWithWave pricingActive={activeSection === 'pricing'} />
    </div>
  );
}

export default App; 